import OBTScrollbar from './OBTScrollbar';

export default OBTScrollbar;